export default {
  title: 'Support Access',
  username: 'User:',
  password: 'Password:',
  nif: 'NIF:',
  promoterCode: 'Promotora:',
  button: 'Login',
  impersonateUsername: 'Usuario a suplantar',
  selectImpersonateUsername: 'Por favor, seleccione el usuario a suplantar',
  validate: {
    username: 'Usuario',
    password: 'Password',
    nif: 'Nif',
    appUser: 'Usuario Oauth2',
    appPassword: 'Password Oauth2'
  },
  environment: 'Entorno',
  issues: {
    title: 'Soporte técnico',
    subject: 'Asunto',
    email: 'Email',
    comments: 'Comentarios',
    send: 'Enviar',
    cancel: 'Cancelar',
    success: 'Se ha informado del problema. El título y el número del caso son:',
    getError: 'Servicio no disponible. Por favor, inténtelo de nuevo más tarde o póngase en contacto con nosotros en:',
    reportError: 'Lo sentimos. Se ha producido un error al enviar del caso. Por favor, inténtelo de nuevo más tarde o póngase en contacto con nosotros en:',
    validationError: 'Datos inválidos',
    search: {
      title: 'Búsqueda',
      from: 'Desde',
      to: 'Hasta',
      number: 'Número de caso',
      status: 'Estado'
    },
    headers: {
      created: 'Creado',
      number: 'Número',
      subject: 'Asunto',
      status: 'Estado'
    },
    status: {
      active: 'Activo',
      resolved: 'Resuelto',
      closed: 'Cerrado',
      reactivated: 'Reactivado',
      any: 'Cualquiera'
    }
  }
}
